import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LuShoppingBag } from "react-icons/lu";
import { CgProfile } from "react-icons/cg";
import { IoIosCart } from "react-icons/io";
import { AiOutlineLogout } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "./store/slices/pubLoginSlice";

export default function NavPublicUser() {
  const navbarBrandStyle = {
    fontFamily: "Garamond, serif",
    fontSize: "1.75rem",
    color: "#1d1e1e",
    margin: 0,
    cursor: "pointer",
    // display and alignItems removed – handled by parent flex container below
  };

  const navbarStyle = {
    minHeight: "60px",
    display: "flex",
    alignItems: "center",
    paddingTop: "5px",
    paddingBottom: "5px",
  };

  const logoStyle = {
    height: "auto",
    width: "clamp(50px, 6vw, 60px)",
   
    cursor: "pointer",
  };

  const nav = useNavigate();
  const location = useLocation();
  const phoneNo = useSelector(state => state.pubLogin.userPhone);
  const dispatch = useDispatch();

  const handleCartClick = () => {
    nav("/pubCart", { state: { phoneNo } });
  };

  const handleBagClick = () => {
    nav("/pubBag", { state: { phoneNo } });
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (confirmLogout) {
      dispatch(logout());
      nav("/");
    }
  };

  const handleHome = () => {
    nav("/publicUser");
  };

  const handleProfile = () => {
    nav("/pubProfile", { state: { phoneNo } });
  };

  const isNotOnPubCartPage = location.pathname !== "/pubCart";
  const isNotOnPubBagPage = location.pathname !== "/pubBag";
  const isNotOnPubProfilePage = location.pathname !== "/pubProfile";

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light " style={navbarStyle}>
        {/* Flexbox container groups logo + h2 side by side */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft:"10px",
            flexShrink: 0,
            whiteSpace: "nowrap"
          }}
        >
          <img
            src="/thedata/LogoTDRS.png"
            alt="Logo"
            onClick={handleHome}
            style={logoStyle}
          />
          <h2
            style={navbarBrandStyle}
            onClick={handleHome}
          >
            The Dry Fruit Shop
          </h2>
        </div>

        <button
          className="navbar-toggler mr-2"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav ml-auto">
            {isNotOnPubCartPage && (
              <button
                className="btn btn-outline-dark ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                onClick={handleCartClick}
              >
                <IoIosCart className="mb-1 mr-1" />
                Cart
              </button>
            )}
            {isNotOnPubBagPage && (
              <button
                className="btn btn-outline-success ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                onClick={handleBagClick}
              >
                <LuShoppingBag className="mb-1 mr-1" />
                Bag
              </button>
            )}
            {isNotOnPubProfilePage && (
              <button
                className="btn btn-outline-light ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                onClick={handleProfile}
              >
                <CgProfile className="mb-1 mr-1" />
                Profile
              </button>
            )}
            <button
              className="btn btn-outline-danger ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow"
              onClick={handleLogout}
            >
              <AiOutlineLogout className="mb-1 mr-1" />
              Logout
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
}
